import getters from '@/store/lib/getters'

export default {
  ...getters,

  updatable: (state) => {
    if (state.password === '') return false
    if (state.confirm === '') return false
    if (state.password !== state.confirm) return false
    return true
  }
}
